





















































































































































































module.exports =
  name: 'planning_modal'
  components:
    reserves_example: require('./planning_modal_example.vue').default
  data: ->
    modal_step: 0
    visible:
      example1: false
      example2: false
      example3: false
  watch:
    modal_step: ->
      @visible.example1 = @visible.example2 = @visible.example3 = false
      @$nextTick -> $(".modal.is-active .modal-card-body").scrollTop(0)
  methods:
    close: ->
      @$store.state.ui.forecast.planning_modal_visible = false
